












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class FormTextarea extends Vue {
  @Prop({ required: true })
  readonly value!: string | number | null;

  @Prop({ required: false, type: [String, Number], default: () => '2' })
  readonly rows!: string | number;

  @Prop({ required: false, type: Array })
  errors!: string[];

  @Prop({ required: false, type: Boolean, default: false })
  readonly autoResize!: boolean;

  mounted() {
    this.resize();
  }

  updated() {
    this.resize();
  }

  onInput(event: Event) {
    this.$emit('input', (event.target as HTMLTextAreaElement).value);
    this.resize();
  }

  resize() {
    if (this.autoResize && this.$refs.textarea) {
      const textarea = this.$refs.textarea as HTMLTextAreaElement;
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    }
  }
}
